function Italy({ dimensions }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1408)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M32 15.9999C32 9.12049 27.658 3.2558 21.5652 0.995117V31.0048C27.658 28.7441 32 22.8794 32 15.9999Z" fill="#D80027"/>
        <path d="M0 15.9999C0 22.8794 4.342 28.7441 10.4348 31.0047V0.995117C4.342 3.2558 0 9.12049 0 15.9999Z" fill="#6DA544"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Italy;
